export interface SaveFileBlobOptions {
  fileName: string;
  fileBlob: Blob;
}

export function saveFileBlob(options: SaveFileBlobOptions): void {
  const downloadLink = document.createElement("a");
  downloadLink.href = window.URL.createObjectURL(options.fileBlob);
  downloadLink.download = options.fileName;
  downloadLink.click();
  downloadLink.remove();
}

export interface SaveTextFileOptions {
  fileName: string;
  fileContent: string;
}

export function saveTextFile(options: SaveTextFileOptions): void {
  const { fileName, fileContent } = options;
  const fileBlob = new Blob([fileContent], { type: "text/plain" });
  saveFileBlob({ fileName, fileBlob });
}

export async function openResponsePdfInNewTab(resp: Response): Promise<void> {
  const blob = await resp.blob();
  const pdfBlob =
    blob.type === "application/pdf"
      ? blob
      : new Blob([blob], { type: "application/pdf" });
  const objectUrl = window.URL.createObjectURL(pdfBlob);
  window.open(objectUrl, "_blank", "noopener,noreferrer");
}
